let initialState = {
    tasksListLoaded: false,
    tasksList: [],
    editable: false
};

export default initialState;